export const TIME_INTERVAL = {
    '45_MIN': 45 * 60 * 1000,
    '50_MIN': 50 * 60 * 1000,
};
